import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { getTypeName } from '../../../models/TAHLocation'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '位置名称',
      dataIndex: 'local',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.local ? t.local : '-'
      },
    },
    {
      title: '类型',
      dataIndex: 'type',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.type? getTypeName(t.type?.toString()) : '-'
      },
    },
    {
      title: '温度范围下限',
      dataIndex: 'temperatureRangLow',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.temperatureRangLow ? t.temperatureRangLow + '℃' : '-'
      },
    },
    {
      title: '温度范围上限',
      dataIndex: 'temperatureRangHight',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.temperatureRangHight ? t.temperatureRangHight  + '℃': '-'
      },
    },
    {
      title: '湿度范围下限',
      dataIndex: 'humidityRangLow',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.humidityRangLow ? t.humidityRangLow  + '%': '-'
      },
    },
    {
      title: '湿度范围上限',
      dataIndex: 'humidityRangHight',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.humidityRangHight ? t.humidityRangHight  + '%': '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
